<template>
    <div id="app">
        <main-header nowtab="wdmota"></main-header>
        <main class="adjuster">
            <a-card size="small" class="card dashboard-card">
                <a-row :gutter="8">
                    <a-col :span="5">
                        <!-- <a-radio-group v-model="sortmode" @change="onChange">
                            <a-radio-button value="hotest">
                                最热
                            </a-radio-button>
                            <a-radio-button value="latest">
                                最新
                            </a-radio-button>
                        </a-radio-group> -->
                    </a-col>
                    <a-col :span="14">
                        <a-input-search v-model="searchstr" placeholder="查找魔塔" enter-button @search="search()" />
                    </a-col>
                    <a-col :span="5" class="extra">
                        <a class="helper" @click="help" href="javascript:void 0">
                            <a-icon type="question-circle" />板块说明
                        </a>
                    </a-col>
                </a-row>
                <a-row :gutter="8">

                </a-row>
            </a-card>
            <a-pagination :current="Number(page)" :total="Number(total)" 
                :defaultPageSize="20" @change="turnPage" :hideOnSinglePage="true"
            />
            <a-spin :spinning="loading" class="tower-list-container">
                <ul class="tower-list">
                    <wdmota-card
                        v-for="tower of towers" :key="tower.name" :tower="tower"
                    />
                </ul>
            </a-spin>
            <a-pagination :current="Number(page)" :total="Number(total)" 
                :defaultPageSize="20" @change="turnPage" :hideOnSinglePage="true"
            />
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import WDMOTACard from '../../components/WDMOTACard.vue';
import { createFormData } from '../../utils/utils';
import axios from 'axios';

export default {
    data: () => ({
        page: 1,
        total: 0,
        searchstr: "",
        loading: false,
        towers: [],
        searchHandle: null,
    }),
    computed: {

    },
    created() {
        const url = new URLSearchParams(window.location.search);
        // this.searchstr = url.has("q") ? url.get("q") : "";
        this.search();
    },
    methods: {
        turnPage(page) {
            this.page = page;
            this.search(true);
        },
        async search(keepPage = false, params = {}) {
            this.loading = true;
            if (this.searchHandle) this.searchHandle.cancel();
            this.searchHandle = axios.CancelToken.source();
            if (!keepPage) {
                this.page = 1;
            }
            const { searchstr, page } = this;
            const { data } = await axios
                .post("/backend/wdtower/list.php", createFormData({
                    searchstr, page, ...params
                }), {
                    cancelToken: this.searchHandle.token,
                });
            this.towers = data.towers;
            this.total = Number(data.total);
            this.loading = false;
        },
        help() {
            this.$info({
                title: 'WDMOTA专区',
                content: h => (
                    <div>
                        <p>本区收集了来自<a href="https://wdmota.com" target="_blank">WDMOTA</a>的魔塔</p>
                        <p>如果作者希望在本区发塔，需要首先在WDMOTA上发布，然后联系H5大群群主进行操作</p>
                    </div>
                ),
                onOk() {},
            });
        },
    },
    components: {
        MainHeader, Footer,
        wdmotaCard: WDMOTACard,
    },
};
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #e6e6e6 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    width: 100%;
    @media screen and (min-width: 1000px) {
        margin: 20px auto;
    }
    @media screen and (max-width: 999px) {
        margin: 0 auto;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.dashboard-card {
    transition: none;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
        margin-top: 0;
    }
}
.extra {
    line-height: 32px;
    .ant-tag {
        font-size: 14px;
    }
}
.helper {
    font-size: 12px;
    color: inherit;
    white-space: nowrap;
}
.tower-list-container {
    margin: 10px 0;
    width: 100%;
}
.tower-list {
    margin: 0 auto;
    padding: 0;
    width: 94%;
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    @media screen and (max-width: 600px) {
        width: 96%;
    }
}
</style>
